import request from "@/utils/request"

export default function agentWithdrawToDouGong(params) {
    return request({
        url: `/fund/withdrawLog/agentWithdrawToDouGong`,
        params
    })
}
